export const API_ROOT = 'https://api.fybrlyte.fybr-tech.com/v1/'; // prod
// export const API_ROOT = 'http://localhost:8640/v1/'; // dev
export const LOGIN_API_ROOT = API_ROOT;
export const LIGHT_API = API_ROOT + 'devices';
export const SITES_API = API_ROOT + 'sites';
export const GROUP_API = API_ROOT + 'groups';


